import React from 'react';
import { Clock, Zap } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownTimer() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown();
  return <div className={`fixed top-0 left-0 right-0 z-40 ${isUrgent ? 'bg-[#A63E28]' : 'bg-gradient-to-r from-[#1B5E4B] to-[#2D7A65]'} text-white py-2.5 shadow-lg transition-colors duration-500`} data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-center gap-3" data-id="element-2">
        {isUrgent ? <Zap className="w-4 h-4 animate-pulse text-[#E8A838]" data-id="element-3" /> : <Clock className="w-4 h-4 text-emerald-200" data-id="element-4" />}
        <div className="flex items-center gap-2" data-id="element-5">
          <span className="font-medium text-xs md:text-sm tracking-wide" data-id="element-6">
            {isUrgent ? '🔥 ¡Últimos minutos!' : '⚡ Oferta especial termina en:'}
          </span>
          <div className="flex items-center gap-1" data-id="element-7">
            <div className={`bg-white/15 backdrop-blur-sm rounded px-2 py-0.5 min-w-[36px] text-center ${isUrgent ? 'animate-pulse bg-white/25' : ''}`} data-id="element-8">
              <span className="font-bold text-base md:text-lg tabular-nums" data-id="element-9">
                {String(minutes).padStart(2, '0')}
              </span>
            </div>
            <span className="font-bold text-base md:text-lg animate-pulse" data-id="element-10">
              :
            </span>
            <div className={`bg-white/15 backdrop-blur-sm rounded px-2 py-0.5 min-w-[36px] text-center ${isUrgent ? 'animate-pulse bg-white/25' : ''}`} data-id="element-11">
              <span className="font-bold text-base md:text-lg tabular-nums" data-id="element-12">
                {String(seconds).padStart(2, '0')}
              </span>
            </div>
          </div>
          <span className="hidden md:inline text-xs text-emerald-200/80 ml-1" data-id="element-13">
            · +2.400 docentes ya accedieron
          </span>
        </div>
      </div>
    </div>;
}